<app-modal-container [title]="title"
                     [actionButtonName]="'Ok'"
                     (action)="confirm()">
  <div class="pb-2">
    <div class="mb-3">Changes you have made may not be saved if your user session expires.</div>
    <div>Please navigate and save your changes to avoid these being lost.</div>
  </div>
</app-modal-container>
